import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
// import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: "#009e91", // 141838
        primary_text: "#c9eae8", // 141838
        secondary: "#FFF", //F7A400
        navbar: "#FFFFFF",
        error: "#b71c1c",
        info: "#71b2f9",
      },
    },
  },
});
